import "./tokens-details.css";
import {
  base64ToBlob,
} from "../../../utils";

import { useVerifyUserHook } from "./useVerifyUserHook";

const VerifyUsers = () => {
  const {
    users,
    loadRecord,
    isLoading,
    setSearchTerm,
    recordCount,
    setRecordCount,
    auth,
    getUsers,
    filterHandler,
    updateStatus,
  } = useVerifyUserHook();

  return (
    <div className="container mt-4">
      <h4 className="text-success  mb-4">User Management</h4>
      <hr />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <label htmlFor="entries" className="form-label me-2 fw-bolder">
            Show
          </label>
          <select
            id="entries"
            onChange={(e) => setRecordCount(e.target.value)}
            className="form-select d-inline-block w-auto"
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span className="ms-2 fw-bolder">entries</span>
        </div>
        <div>
          <label htmlFor="search" className="form-label me-2 fw-bolder">
            Search:
          </label>
          <input
            id="search"
            onChange={(e) => setSearchTerm(e.target.value)}
            type="text"
            className="form-control d-inline-block w-auto"
          />
        </div>
      </div>
      {isLoading && (
        <div className="loader-wrapper">
          <i className="fas fa-spinner fa-spin"></i>
        </div>
      )}

      {!isLoading && (
        <div className="table-responsive">
          <table className="table table-bordered custom-table">
            <thead>
              <tr>
                <th>Member Id</th>
                <th>Full Name</th>
                <th>Emails</th>
                <th>Documents</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users
                .filter(filterHandler)
                .slice(0, recordCount)
                .map((user) => (
                  <tr key={user.member_id}>
                    <td>{user.member_id}</td>
                    <td>
                      {user.first_name}&nbsp;{user.last_name}
                    </td>
                    <td>{user.email}</td>
                    <td>
                      {user.uploads.map((document, index) => (
                        <>
                          <a
                            target="_blank"
                            href={base64ToBlob(document.data)}
                            key={`${user.member_id}-${index}`}
                          >
                            {document.title}
                          </a>
                          <br />
                        </>
                      ))}
                    </td>
                    <td>
                      <button
                        disabled={loadRecord.hasOwnProperty(user.id)}
                        onClick={() => updateStatus(user)}
                        className={[
                          "btn",
                          user.status == 0 ? "btn-danger" : "btn-success",
                        ].join(" ")}
                      >
                        {loadRecord.hasOwnProperty(user.id) ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : user.status == 0 ? (
                          "Not Verified"
                        ) : (
                          "Verified"
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VerifyUsers;
